import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { Injectable, inject } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
class RoleAccessGuardService {
  constructor(
    private _router: Router,
    private authService: UserAuthenticationService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getUser();
    const userModulesMetadata = user.userModuleRoles.map((x: any) => JSON.parse(x.module.metadata));
    const userModulesMetadataWithModuleId = user.userModuleRoles.map((x: any) => ({
      moduleId: x.module.moduleId,
      role: x.role,
      metadata: JSON.parse(x.module.metadata)
    }));

    const routeData = next.data;
    const moduleData = routeData['module'];
    const routeModule = userModulesMetadata.find((x: any) => x.label === moduleData);

    // Add null check here to prevent crash
    if (!routeModule) {
      this._router.navigate(['']);
      return false;
    }

    const routeModuleRole = userModulesMetadataWithModuleId.find((x: any) => x.metadata.label === routeModule.label);

    if (routeModuleRole) {
      this.authService.UserSelectedModule = routeModule;
      this.authService.UserModule = userModulesMetadata;
      this.authService.setUserRole({
        displayName: routeModuleRole.role.displayName,
        roleId: routeModuleRole.role.roleId,
        roleName: routeModuleRole.role.roleName
      });

      if (
        routeModule.label === 'Sales' &&
        routeModuleRole.role.roleName === 'ReportsUser' &&
        !state.url.startsWith('/sales/reports')
      ) {
        this._router.navigate(['/sales/reports/sales-listings']);
        return false;
      }

      return true;
    }

    this._router.navigate(['']);
    return false;
  }
}
export const RoleAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(RoleAccessGuardService).canActivate(next, state);
};
